<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="-11.5 780.5 24 24">
<path d="M-3.642,782.5l-5.858,5.858v8.283l5.858,5.858h8.284l5.858-5.858v-8.283L4.642,782.5H-3.642z M-3.828,788.17h8.655v8.661
	h-8.655V788.17z"/>
</svg>

</template>